/* eslint-disable */

/**
 * helper function for leading zeros in e.g. an image sequence in filepaths
 */
export function paddy (n, p, c) {
  var padChar = typeof c !== 'undefined' ? c : '0'
  var pad = new Array(1 + p).join(padChar)
  return (pad + n).slice(-pad.length)
}

/**
 * missing clamp function
 */
export function clamp (min, max) {
  return Math.min(Math.max(this, min), max)
}

// Returns true if it is a DOM node
export function isNode (o) {
  return (
    typeof Node === 'object' ? o instanceof Node :
    o && typeof o === 'object' && typeof o.nodeType === 'number' && typeof o.nodeName === 'string'
  )
}

export function isSubObject (obj, subObj) {
  var type
  if ((type = typeof obj) !== typeof subObj) {
    return false
  }
  if (type !== 'object') {
    return obj === subObj
  }
  if ((obj !== null && subObj === null) || (obj !== null && subObj === null)) return false
  if (obj === null && subObj === null) return true
  var contains = true
  for (let p in obj) {
    contains = contains && isSubObject(obj[p], subObj[p])
  }
  return contains
}

// Returns true if it is a DOM element
export function isElement (o) {
  return o instanceof Element
}

// Returns true if o is a number
export function isNum (o) {
  return typeof o === 'number'
}

export function isBool (o) {
  return typeof o === 'boolean'
}

export function isStr (o) {
  return typeof o === 'string'
}
// Returns true if o is an array
export function isArray (a) {
  return Array.isArray(a)
}

// Returns true if o is undefined
export function isUndef (o) {
  return typeof o === 'undefined'
}

// checks if the given parameter is a query selector or a DOM Element
// and returns a DOM Element, if it is neiter or no element was found, it returns undefined
export function getElement (el) {
  if (isElement(el)) {
  } else if (typeof el === 'string' && (el = document.querySelector(el))) {
  } else return undefined
  return el
}
// creates a deep clone of an object or any other type
export function clone (obj) {
  var copy

  // Handle the 3 simple types, and null or undefined
  if (obj === null || typeof obj !== 'object') return obj

  // Handle Date
  if (obj instanceof Date) {
    copy = new Date()
    copy.setTime(obj.getTime())
    return copy
  }

  // Handle Array
  if (obj instanceof Array) {
    copy = []
    for (var i = 0, len = obj.length; i < len; i++) {
      copy[i] = clone(obj[i])
    }
    return copy
  }

  // Handle Object
  if (obj instanceof Object) {
    copy = {}
    for (var attr in obj) {
      if (obj.hasOwnProperty(attr)) copy[attr] = clone(obj[attr])
    }
    return copy
  }

  throw new Error("Unable to copy obj! Its type isn't supported.")
}

export function allDescendants (vueInst) {
  var children = vueInst.$children
  if (children) {
    var descendants = []
    children.forEach(c => { descendants = descendants.concat(allDescendants(c)) })
    return children.concat(descendants)
  } else return []
}
